// export const colorCodeData = {
//   "Aluminium": { material: "PVC Rolling Shutter", unitCost: 0, shutterPrice: 0 },
//   "Black": { material: "PVC Rolling Shutter", unitCost: 0, shutterPrice: 0 },
//   "White": { material: "PVC Rolling Shutter", unitCost: 0, shutterPrice: 0 },
//   "GA-4031": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
//   "GA-4808": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
//   "GA-4601": { material: "Gloss", unitCost: 810, shutterPrice: 810 },
//   "40268 MR+": { material: "Stagger Marble", unitCost: 720, shutterPrice: 720 },
//   "21109 MR+": { material: "Moss Grey", unitCost: 720, shutterPrice: 720 },
//   "21069 UNI+": { material: "Silver Grey", unitCost: 755, shutterPrice: 755 },
//   "21071 FT": { material: "Smoke", unitCost: 540, shutterPrice: 540 },
//   "21027 FT": { material: "Irish Cream", unitCost: 540, shutterPrice: 540 },
//   "49931 SHV": { material: "Alumina Pearl", unitCost: 720, shutterPrice: 720 },
//   "21342": { material: "Twilight (Matt)", unitCost: 540, shutterPrice: 540 },
//   "22122 HGL": { material: "Shore", unitCost: 810, shutterPrice: 810 },
//   "37382 LV": { material: "Wilderness Walnut", unitCost: 540, shutterPrice: 540 },
//   "21162": { material: "Winter Sea (Matt)", unitCost: 540, shutterPrice: 540 },
//   "GA-4028": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
//   "21091 UNI+": { material: "Frosty White", unitCost: 755, shutterPrice: 755 },
//   "21162 MR+": { material: "Winter Sea (Gloss)", unitCost: 810, shutterPrice: 810 },
//   "GA-4806": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
//   "27151 LV": { material: "Harbor Grey", unitCost: 540, shutterPrice: 540 },
//   "3473": { material: "Carrara Marble", unitCost: 665, shutterPrice: 665 },
//   "3475": { material: "Glacier Stone", unitCost: 665, shutterPrice: 665 },
//   "1153": { material: "Midnight Blue", unitCost: 665, shutterPrice: 665 },
//   "1154": { material: "Wasabi Green", unitCost: 665, shutterPrice: 665 },
//   "3462": { material: "Natural Walnut", unitCost: 665, shutterPrice: 665 },
//   "27292 LV": { material: "Mink", unitCost: 540, shutterPrice: 540 },
//   "21941": { material: "Candy White", unitCost: 540, shutterPrice: 540 },
//   "1104": { material: "Silver Grey", unitCost: 665, shutterPrice: 665 },
//   "21342 MR+": { material: "Twilight (Gloss)", unitCost: 810, shutterPrice: 810 }
  
// // };


export const colorCodeData = {
  // Basic
  "Aluminium": { material: "PVC Rolling Shutter", unitCost: 0, shutterPrice: 0 },
  "Black": { material: "PVC Rolling Shutter", unitCost: 0, shutterPrice: 0 },
  "White": { material: "PVC Rolling Shutter", unitCost: 0, shutterPrice: 0 },

  // Non-GA Laminates
  "40268 MR+": { material: "Stagger Marble", unitCost: 720, shutterPrice: 720 },
  "21109 MR+": { material: "Moss Grey", unitCost: 720, shutterPrice: 720 },
  "21069 UNI+": { material: "Silver Grey", unitCost: 755, shutterPrice: 755 },
  "21071 FT": { material: "Smoke", unitCost: 540, shutterPrice: 540 },
  "21027 FT": { material: "Irish Cream", unitCost: 540, shutterPrice: 540 },
  "49931 SHV": { material: "Alumina Pearl", unitCost: 720, shutterPrice: 720 },
  "21342": { material: "Twilight (Matt)", unitCost: 540, shutterPrice: 540 },
  "22122 HGL": { material: "Shore", unitCost: 810, shutterPrice: 810 },
  "37382 LV": { material: "Wilderness Walnut", unitCost: 540, shutterPrice: 540 },
  "21162": { material: "Winter Sea (Matt)", unitCost: 540, shutterPrice: 540 },
  "21091 UNI+": { material: "Frosty White", unitCost: 755, shutterPrice: 755 },
  "21162 MR+": { material: "Winter Sea (Gloss)", unitCost: 810, shutterPrice: 810 },
  "27151 LV": { material: "Harbor Grey", unitCost: 540, shutterPrice: 540 },
  "27292 LV": { material: "Mink", unitCost: 540, shutterPrice: 540 },
  "21941": { material: "Candy White", unitCost: 540, shutterPrice: 540 },
  "21342 MR+": { material: "Twilight (Gloss)", unitCost: 810, shutterPrice: 810 },

  // Ornamatte (All @ 665)
  "1131": { material: "Mud Ash", unitCost: 665, shutterPrice: 665 },
  "1106": { material: "Black", unitCost: 665, shutterPrice: 665 },
  "1157": { material: "Brown Cappuccino", unitCost: 665, shutterPrice: 665 },
  "1134": { material: "Mocha Brown", unitCost: 665, shutterPrice: 665 },
  "3462": { material: "Natural Walnut", unitCost: 665, shutterPrice: 665 },
  "3461": { material: "Novel Walnut", unitCost: 665, shutterPrice: 665 },
  "3471": { material: "Virgin Oak", unitCost: 665, shutterPrice: 665 },
  "3472": { material: "Auburn Oak", unitCost: 665, shutterPrice: 665 },
  "1120": { material: "Irish Cream", unitCost: 665, shutterPrice: 665 },
  "1155": { material: "Warm Brown", unitCost: 665, shutterPrice: 665 },
  "1154": { material: "Wasabi Green", unitCost: 665, shutterPrice: 665 },
  "1142": { material: "Pebble Beech", unitCost: 665, shutterPrice: 665 },
  "1136": { material: "Ocean Green", unitCost: 665, shutterPrice: 665 },
  "1143": { material: "Coral Pink", unitCost: 665, shutterPrice: 665 },
  "1141": { material: "Night Grey", unitCost: 665, shutterPrice: 665 },
  "1156": { material: "Plum", unitCost: 665, shutterPrice: 665 },
  "1102": { material: "Everest White", unitCost: 665, shutterPrice: 665 },
  "1103": { material: "Frosty White", unitCost: 665, shutterPrice: 665 },
  "1104": { material: "Silver Grey", unitCost: 665, shutterPrice: 665 },
  "1152": { material: "Warm Blue", unitCost: 665, shutterPrice: 665 },
  "1113": { material: "Gothic Grey", unitCost: 665, shutterPrice: 665 },
  "1137": { material: "Persian Blue", unitCost: 665, shutterPrice: 665 },
  "1151": { material: "Mouse Grey", unitCost: 665, shutterPrice: 665 },
  "1153": { material: "Midnight Blue", unitCost: 665, shutterPrice: 665 },
  "3473": { material: "Carrara Marble", unitCost: 665, shutterPrice: 665 },
  "1101": { material: "Super White", unitCost: 665, shutterPrice: 665 },
  "3474": { material: "Grey Stone", unitCost: 665, shutterPrice: 665 },
  "3469": { material: "Calm Nubuck", unitCost: 665, shutterPrice: 665 },
  "3467": { material: "Milk Statuary Marble", unitCost: 665, shutterPrice: 665 },
  "3470": { material: "Chick Nubuck", unitCost: 665, shutterPrice: 665 },
  "3475": { material: "Glacier Stone", unitCost: 665, shutterPrice: 665 },
  "1105": { material: "Slate Grey", unitCost: 665, shutterPrice: 665 },

  // GA Acrylic (All @ 810)
  "GA-01": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-02": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-03": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-04": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },

  "GA-4001": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4002": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4003": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4004": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4005": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4006": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4007": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4008": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4009": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },

  "GA-4010": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4011": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4012": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4013": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4014": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4016": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4018": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4019": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },

  "GA-4020": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4022": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4023": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4026": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4027": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4028": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4029": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },

  "GA-4030": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4031": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4032": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4033": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4034": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4035": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4036": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4037": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4038": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4039": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4040": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },

  "GA-4111": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4112": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4128": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4129": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4143": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },

  "GA-4403": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4404": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4407": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4408": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4409": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4410": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4411": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4412": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4414": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4415": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4417": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4418": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4419": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },

  "GA-4420": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4421": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4422": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4423": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4424": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4425": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },

  "GA-4601": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4602": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4603": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4605": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4606": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4607": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4608": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4609": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4610": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },

  "GA-4801": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4803": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4805": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4806": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4807": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4808": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },

  "GA-4811": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4812": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4813": { material: "Acrylic", unitCost: 810, shutterPrice: 810 },
  "GA-4814": { material: "Acrylic", unitCost: 810, shutterPrice: 810 }
};

export const cabinetTypes = [
  "Base Cabinet",
  "Wall Cabinet",
  "Tall Cabinet",
  "Sink Base",
  "Corner Cabinet",
  "Magic Corner",
  "Lazy Susan",
  "Spice Rack",
  "Wooden Cutlery",
  "Stainless Steel Cutlery",
  "Dish Rack",
  "Utensils Drawer Rack",
  "Bowl Holder",
  "Plate Holder",
  "Sliding Waste Bin",
  "Garbage Base",
  "Drawer Base",
  "Stainless Steel Drawer",
  "Tandem Drawer",
  "Stainless Steel Bucket",
  "G-Profile",
  "J-Profile",
  "Knob",
  "Filler",
  "Panel",
  "Liner",
  "Tile",
  "Backsplash",
  "Vinyl",
  "Glass Door",
  "Corner Base",
  "Corner Wall",
  "Pantry",
  "Base - No Drawer",
  "Microwave Oven Pantry",
  "Double Oven Pantry",
"PVC Rolling Shutter",
 "Profile Handle"
];

export const profileHandlePrices = {
  "6": 70,
  "8": 94,
  "10": 117,
  "12": 140,
  "14": 164,
  "16": 187,
  "18": 211,
  "20": 234,
  "22": 257,
  "24": 281,
  "30": 351,
  "36": 421
};


export const fixedPriceItems = {
  "Magic Corner": 800,
  "Lazy Susan": 400,
  "Spice Rack": 200,
  "Wooden Cutlery": 60,
  "Stainless Steel Cutlery": 150,
  "Dish Rack": 150,
  "Bowl Holder": 50,
  "Plate Holder": 60,
  "Sliding Waste Bin": 200,
  "Stainless Steel Drawer": 150,
  "Tandem Drawer": 175,
  "G-Profile": 15,
  "J-Profile": 15,
  "PVC Rolling Shutter": 0,
  "Assembly": 50,
  "Installation": 150,
  "Delivery": 150,
};

export const pvcRollingShutterSizes = {
  "16x12x52": 600,
  "22x12x52": 750,
  "34x12x52": 900,

};


export const shakerData = [
  { item: "W0930", description: 'Wall 9"W*30"H*12"D-1D-2S', unitcost: 139.35 },
  { item: "W1230", description: 'Wall 12"W*30"H*12"D-1D-2S', unitcost: 157.1 },
  { item: "W1530", description: 'Wall 15"W*30"H*12"D-1D-2S', unitcost: 180.55 },
  { item: "W1830", description: 'Wall 18"W*30"H*12"D-1D-2S', unitcost: 202.6 },
  { item: "W2130", description: 'Wall 21"W*30"H*12"D-1D-2S', unitcost: 223.8 },
  { item: "W2430", description: 'Wall 24"W*30"H*12"D-2D-2S', unitcost: 265.25 },
  { item: "W2730", description: 'Wall 27"W*30"H*12"D-2D-2S', unitcost: 284.1 },
  { item: "W3030", description: 'Wall 30"W*30"H*12"D-2D-2S', unitcost: 309.2 },
  { item: "W3330", description: 'Wall 33"W*30"H*12"D-2D-2S', unitcost: 328.2 },
  { item: "W3630", description: 'Wall 36"W*30"H*12"D-2D-2S', unitcost: 349.05 },
  { item: "W0936", description: 'Wall 9"W*36"H*12"D-1D-2S', unitcost: 164.25 },
  { item: "W1236", description: 'Wall 12"W*36"H*12"D-1D-2S', unitcost: 183.35 },
  { item: "W1536", description: 'Wall 15"W*36"H*12"D-1D-2S', unitcost: 206.95 },
  { item: "W1836", description: 'Wall 18"W*36"H*12"D-1D-2S', unitcost: 231.85 },
  { item: "W2136", description: 'Wall 21"W*36"H*12"D-1D-3S', unitcost: 254.7 },
  { item: "W2436", description: 'Wall 24"W*36"H*12"D-2D-2S', unitcost: 298.75 },
  { item: "W2736", description: 'Wall 27"W*36"H*12"D-2D-2S', unitcost: 321.6 },
  { item: "W3036", description: 'Wall 30"W*36"H*12"D-2D-2S', unitcost: 348.6 },
  { item: "W3336", description: 'Wall 33"W*36"H*12"D-2D-2S', unitcost: 373.95 },
  { item: "W3636", description: 'Wall 36"W*36"H*12"D-2D-2S', unitcost: 398.3 },
  { item: "W0942", description: 'Wall 9"W*42"H*12"D-1D-3S', unitcost: 189.4 },
  { item: "W1242", description: 'Wall 12"W*42"H*12"D-1D-3S', unitcost: 211.75 },
  { item: "W1542", description: 'Wall 15"W*42"H*12"D-1D-3S', unitcost: 246.4 },
  { item: "W1842", description: 'Wall 18"W*42"H*12"D-1D-3S', unitcost: 269.85 },
  { item: "W2142", description: 'Wall 21"W*42"H*12"D-1D-3S', unitcost: 295.25 },
  { item: "W2442", description: 'Wall 24"W*42"H*12"D-2D-3S', unitcost: 351.5 },
  { item: "W2742", description: 'Wall 27"W*42"H*12"D-2D-3S', unitcost: 382.4 },
  { item: "W3042", description: 'Wall 30"W*42"H*12"D-2D-3S', unitcost: 408.55 },
  { item: "W3342", description: 'Wall 33"W*42"H*12"D-2D-3S', unitcost: 434.45 },
  { item: "W3642", description: 'Wall 36"W*42"H*12"D-2D-3S', unitcost: 458.65 },
  { item: "W3012", description: 'Wall 30"W*12"H*12"D-2D', unitcost: 156.4 },
  { item: "W3015", description: 'Wall 30"W*15"H*12"D-2D', unitcost: 176.35 },
  { item: "W3018", description: 'Wall 30"W*18"H*12"D-2D', unitcost: 191.35 },
  { item: "W3024", description: 'Wall 30"W*24"H*12"D-2D-1S', unitcost: 249.2 },
  { item: "W3612", description: 'Wall 36"W*12"H*12"D-2D', unitcost: 180.2 },
  { item: "W3618", description: 'Wall 36"W*18"H*12"D-2D', unitcost: 218.85 },
  { item: "W3624", description: 'Wall 36"W*24"H*12"D-2D-1S', unitcost: 279.8 },
  { item: "W361224", description: 'Wall 36"W*12"H*24"D-2D', unitcost: 246.2 },
  { item: "W361824", description: 'Wall 36"W*18"H*24"D-2D', unitcost: 293.35 },
  {
    item: "W362424",
    description: 'Wall 36"W*24"H*24"D-2D-1S',
    unitcost: 352.65,
  },
  {
    item: "WDC2430",
    description: 'Wall Diagonal Cabinet 24"W*30"H*24"D-1D-2S',
    unitcost: 363.9,
  },
  {
    item: "WDC2436",
    description: 'Wall Diagonal Cabinet 24"W*36"H*24"D-1D-2S',
    unitcost: 405.05,
  },
  {
    item: "WDC2442",
    description: 'Wall Diagonal Cabinet 24"W*42"H*24"D-1D-3S',
    unitcost: 487.35,
  },
  { item: "WR3015", description: 'Wine Rack 30"W*15"H*12"D', unitcost: 204.9 },
  { item: "B09", description: 'Base 9"W*24"D*34-1/2"H-1D-1S', unitcost: 198.8 },
  {
    item: "B12",
    description: 'Base 12"W*24"D*34-1/2"H-1D-1DRA-1S',
    unitcost: 271.3,
  },
  {
    item: "B15",
    description: 'Base 15"W*24"D*34-1/2"H-1D-1DRA-1S',
    unitcost: 299.5,
  },
  {
    item: "B18",
    description: 'Base 18"W*24"D*34-1/2"H-1D-1DRA-1S',
    unitcost: 327.7,
  },
  {
    item: "B21",
    description: 'Base 21"W*24"D*34-1/2"H-2D-1DRA-1S',
    unitcost: 367.7,
  },
  {
    item: "B24",
    description: 'Base 24"W*24"D*34-1/2"H-2D-1DRA-1S',
    unitcost: 397.5,
  },
  {
    item: "B27",
    description: 'Base 27"W*24"D*34-1/2"H-2D-1DRA-1S',
    unitcost: 425.95,
  },
  {
    item: "B30",
    description: 'Base 30"W*24"D*34-1/2"H-2D-1DRA-1S',
    unitcost: 455.25,
  },
  {
    item: "B33",
    description: 'Base 33"W*24"D*34-1/2"H-2D-2DRA-1S',
    unitcost: 530.4,
  },
  {
    item: "B36",
    description: 'Base 36"W*24"D*34-1/2"H-2D-2DRA-1S',
    unitcost: 559.1,
  },
  {
    item: "BSR09",
    description: 'Base Spice Pull Out 9"W*24"D*34-1/2"H',
    unitcost: 292.85,
  },
  {
    item: "BW18",
    description: 'Base Waste Basket 18"W*24"D*34-1/2"H',
    unitcost: 390.4,
  },
  {
    item: "DB18-3",
    description: 'Base Drawer 18"W*24"D*34-1/2"H-3DRA',
    unitcost: 500.5,
  },
  {
    item: "DB21-3",
    description: 'Base Drawer 21"W*24"D*34-1/2"H-3DRA',
    unitcost: 545.7,
  },
  {
    item: "DB24-3",
    description: 'Base Drawer 24"W*24"D*34-1/2"H-3DRA',
    unitcost: 591.75,
  },
  {
    item: "DB30-3",
    description: 'Base Drawer 30"W*24"D*34-1/2"H-3DRA',
    unitcost: 649.6,
  },
  {
    item: "DB33-3",
    description: 'Base Drawer 33"W*24"D*34-1/2"H-3DRA',
    unitcost: 692.45,
  },
  {
    item: "DB36-3",
    description: 'Base Drawer 36"W*24"D*34-1/2"H-3DRA',
    unitcost: 735.3,
  },
  {
    item: "SB33",
    description: 'Sink Base 33"W*24"D*34-1/2"H-2D-2Header',
    unitcost: 369.8,
  },
  {
    item: "SB36",
    description: 'Sink Base 36"W*24"D*34-1/2"H-2D-2Header',
    unitcost: 404.85,
  },
  {
    item: "LSB36",
    description: 'Laze Susan 36"W*36"D*34-1/2"H-2D-1S-2L',
    unitcost: 690.65,
  },
  {
    item: "WP189624",
    description: 'Pantry 18"W*96"H*24"D-2D-6S',
    unitcost: 796.45,
  },
  {
    item: "WP248424",
    description: 'Pantry 24"W*84"H*24"D-4D-5S',
    unitcost: 894.45,
  },
  {
    item: "WP249024",
    description: 'Pantry 24"W*90"H*24"D-4D-5S',
    unitcost: 944.7,
  },
  {
    item: "WP249624",
    description: 'Pantry 24"W*96"H*24"D-4D-6S',
    unitcost: 1017.1,
  },
  {
    item: "WP308424",
    description: 'Pantry 30"W*84"H*24"D-4D-5S',
    unitcost: 1015.9,
  },
  {
    item: "WP309024",
    description: 'Pantry 30"W*90"H*24"D-4D-5S',
    unitcost: 1069.15,
  },
  {
    item: "WP309624",
    description: 'Pantry 30"W*96"H*24"D-4D-6S',
    unitcost: 1153.1,
  },
  {
    item: "OC339024",
    description: 'Oven Cabinet 33"W*90"H*24"D-2D-1DRA',
    unitcost: 1088.9,
  },
  {
    item: "OC339624",
    description: 'Oven Cabinet 33"W*96"H*24"D-2D-1DRA',
    unitcost: 1132.6,
  },
  {
    item: "VSB24",
    description: 'Vanity Sink Base 24"W*21"D*34-1/2"H-2D-1Header',
    unitcost: 303.5,
  },
  {
    item: "VSB27",
    description: 'Vanity Sink Base 27"W*21"D*34-1/2"H-2D-1Header',
    unitcost: 323,
  },
  {
    item: "GDW1230-Clear",
    description: "Glass door with no hinge",
    unitcost: 56.3,
  },
  {
    item: "GDW1236-Clear",
    description: "Glass door with no hinge",
    unitcost: 66.1,
  },
  {
    item: "GDW1242-Clear",
    description: "Glass door with no hinge",
    unitcost: 76.65,
  },
  {
    item: "GDW1530-Clear",
    description: "Glass door with no hinge",
    unitcost: 67.3,
  },
  {
    item: "GDW1536-Clear",
    description: "Glass door with no hinge",
    unitcost: 79.15,
  },
  {
    item: "GDW1542-Clear",
    description: "Glass door with no hinge",
    unitcost: 91.5,
  },
  {
    item: "GDW1830-Clear",
    description: "Glass door with no hinge",
    unitcost: 78.3,
  },
  {
    item: "GDW1836-Clear",
    description: "Glass door with no hinge",
    unitcost: 91.9,
  },
  {
    item: "GDW1842-Clear",
    description: "Glass door with no hinge",
    unitcost: 106.85,
  },
  {
    item: "GDWDC2430-Clear",
    description: "Glass door with no hinge",
    unitcost: 70.85,
  },
  {
    item: "GDWDC2436-Clear",
    description: "Glass door with no hinge",
    unitcost: 83.35,
  },
  {
    item: "GDWDC2442-Clear",
    description: "Glass door with no hinge",
    unitcost: 96.3,
  },
  {
    item: "ROT18",
    description: 'Roll out tray for 18" cabinet',
    unitcost: 117.75,
  },
  {
    item: "ROT24",
    description: 'Roll out tray for 24" cabinet',
    unitcost: 125.85,
  },
  {
    item: "ROT30",
    description: 'Roll out tray for 30" cabinet',
    unitcost: 135.15,
  },
  {
    item: "WDD1230",
    description: 'Wall decorated door 12"W * 30"L',
    unitcost: 77.15,
  },
  {
    item: "WDD1236",
    description: 'Wall decorated door 12"W * 36"L',
    unitcost: 91.45,
  },
  {
    item: "WDD1242",
    description: 'Wall decorated door 12"W * 42"L',
    unitcost: 105.85,
  },
  {
    item: "BDD2430",
    description: 'Base decorated door 24"W * 30"L',
    unitcost: 129.65,
  },
  {
    item: "BP4896",
    description: 'Decorative plywood panel 48X96X1/4"',
    unitcost: 126.25,
  },
  {
    item: "Panel",
    description: 'Decorative plywood panel 48X96X3/4"',
    unitcost: 0,
  },
  {
    item: "Edge",
    description: "PVC edge band white for shelf one roll",
    unitcost: 0,
  },
  {
    item: "REP396",
    description: 'Refrigerator Panel 3"*24"*96"',
    unitcost: 177.55,
  },
  { item: "TK8", description: 'Toe Kick 1/4"X96"', unitcost: 17.45 },
  { item: "WF336", description: 'Wall fillers 3"W*36"H', unitcost: 25.85 },
  { item: "WF396", description: 'Wall fillers 3"W*42"H', unitcost: 69.1 },
  { item: "WF696", description: 'Wall fillers 6"W*96"H', unitcost: 131.3 },
  { item: "CM8-3", description: 'Crown molding 3"', unitcost: 88.85 },
  { item: "CM8-6", description: 'Crown molding 6"', unitcost: 140.7 },
  {
    item: "OCM8",
    description: 'Outside Corner Molding 3/4"T*3/4"W*96"L',
    unitcost: 20.1,
  },
  {
    item: "Delivery",
    description: 'Delivery',
    unitcost: 150,
  },
  {
    item: "Assembly",
    description: 'Assembly',
    unitcost: 50,
  },
  {
    item: "Installation",
    description: 'Installation',
    unitcost: 150,
  },

];
